import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { initialOperatingStatementsState } from "./OperatingStatements.types";
import { OperatingStatementsActions } from ".";
import {
  CLEAR_OPERATING_STATEMENTS,
  FETCH_OPERATING_STATEMENTS_LIST_FAILED,
  FETCH_OPERATING_STATEMENTS_LIST_PROGRESS,
  FETCH_OPERATING_STATEMENTS_LIST_SUCCESS,
} from "./OperatingStatementsActions";
import { LoadState } from "../../../constants/enums";

export const operatingStatementsReducer = (
  state: IStoreState["accounting"]["operatingStatements"] = initialOperatingStatementsState,
  action: OperatingStatementsActions
) => {
  switch (action.type) {
    case FETCH_OPERATING_STATEMENTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_OPERATING_STATEMENTS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_OPERATING_STATEMENTS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }

    case CLEAR_OPERATING_STATEMENTS: {
      return initialOperatingStatementsState;
    }

    default: {
      return state;
    }
  }
};
